import { Injectable } from '@angular/core';
import { getManifestUrl, validateManifestExists } from '../utils/manifestUtils';

/**
 * Angular service that handles dynamic manifest.webmanifest loading
 * Replaces the static manifest link with proper runtime values
 */
@Injectable({
  providedIn: 'root'
})
export class ManifestService {
  private manifestLink: HTMLLinkElement | null = null;

  /**
   * Initializes the manifest handling
   * Should be called once during app initialization
   */
  async initializeManifest(): Promise<void> {
    try {
      // Remove existing manifest link if it exists
      const existingLink = document.querySelector('link[rel="manifest"]');
      if (existingLink) {
        existingLink.remove();
      }

      // Get the correct manifest URL
      const manifestUrl = getManifestUrl();

      // Create new manifest link
      this.manifestLink = document.createElement('link');
      this.manifestLink.rel = 'manifest';
      this.manifestLink.href = manifestUrl;
      document.head.appendChild(this.manifestLink);

      // Validate the manifest exists (non-blocking)
      try {
        await validateManifestExists(manifestUrl);
      } catch (error) {
        console.warn('Failed to validate manifest:', error);
        // Don't remove the link - let the browser handle the 404
      }
    } catch (error) {
      console.error('Failed to setup manifest:', error);
    }
  }

  /**
   * Cleans up manifest handling
   * Should be called during app destruction if needed
   */
  cleanup(): void {
    if (this.manifestLink && document.head.contains(this.manifestLink)) {
      document.head.removeChild(this.manifestLink);
      this.manifestLink = null;
    }
  }
}